import { useApiClient } from '../client'

export const POST_REFERRALS_CJE_ENDPOINT = '/core/v2/referrals/cje/'

export function postReferralsCje (cjevent: string) {
  const apiClient = useApiClient()

  return apiClient.post<void>({
    url: POST_REFERRALS_CJE_ENDPOINT,
    data: {
      cjevent,
    },
    withCredentials: true,
  })
}
